import States from './States.js';

export default function StatesWithDisabled(disabledStates) {
  let states = States();

  return states.map(item => {
    if (disabledStates.includes(item.value)) {
      item.label = item.label + " (Not Available)";
      item.disabled = true;
    }
    return item;
  });
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/StatesWithDisabled.js